// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"5f9b40a3","778":"b6a9448b","832":"6c0828cb"}[chunkId] + ".chunk.js";
};